import productListInformationFragment from '@data/fragments/products/productListInformation.main'
import gql from 'graphql-tag'

const getCategoryProductsQuery = gql`
  query getCategoryProducts(
    $categoryId: ID
    $menuId: ID
    $format: String
    $page: BigInt
    $limit: Float
    $filter: String
    $sorting: ProductsSortInput
    $productFilters: [String]
    $priceFilters: [PriceFilterInput]
    $storeId: ID
    $deliverAt: Date
  ) {
    category(categoryId: $categoryId) {
      _id
      paginatedProducts(
        filter: $filter
        sorting: $sorting
        limit: $limit
        page: $page
        menuId: $menuId
        productFilters: $productFilters
        priceFilters: $priceFilters
        storeId: $storeId
        deliverAt: $deliverAt
      ) {
        totalCount
        totalPages
        hasNextPage
        hasPreviousPage
        items {
          _id
          modifiers {
            _id
            optional
          }
          categories {
            _id
            name
            internalName
          }
          ...productListInformation
        }
      }
    }
  }
  ${productListInformationFragment}
`
export default getCategoryProductsQuery
